
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class LissajousCurvesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const count = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const A = (width * 0.4) * (1 - i * 0.1);
                const B = (height * 0.4) * (1 - i * 0.1);
                const a = 3 + i;
                const b = 2 + i;
                const delta = curTime + i;

                ctx.beginPath();
                for (let t = 0; t < Math.PI * 2; t += 0.05) {
                    const x = A * Math.sin(a * t + delta);
                    const y = B * Math.sin(b * t);
                    if (t === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.stroke();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
